<template>
<div>
  <v-toolbar flat dense >
    <v-toolbar-title>
      <help-popover >
        This is a list of clients that you've seen within the
        selected daterange
      </help-popover>
      Active clients
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-if='withClose' icon @click="$emit('close')" >
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
  <v-text-field v-if='withSearch'
    v-model='searchString'
    label="Search"
    prepend-icon="search"
    clearable >
  </v-text-field>
  <v-list dense class='pa-0' >
    <template v-for='(relationship, index) in filteredActiveClients' >
      <v-list-tile
        @click='setSelected(relationship, index)'
        :class='{"blue lighten-5": (activeIndex === index) }'
        :key='relationship.id' >
        <v-list-tile-title >
          {{relationship.client.first_name}} {{relationship.client.last_name}}
        </v-list-tile-title>
      </v-list-tile>
      <v-divider :key='`div-${relationship.id}`'></v-divider>
    </template>
  </v-list>
</div>
</template>

<script>
import {
  LIST_ACTIVE_CLIENTS_REQ
} from '@/store/constants'
import HelpPopover from '@/components/ui/HelpPopover'

export default {
  name: 'ActiveClientsList',
  components: { HelpPopover },
  props: {
    withSearch: { type: Boolean, default: true },
    withClose: { type: Boolean, default: false },
    highlightSelected: { type: Boolean, default: true }
  },
  data () {
    return {
      searchString: '',
      activeIndex: -1,
      selectedClient: {}
    }
  },
  mounted () {
    this.getActiveClients()
  },
  watch: {
    globalActiveDateRangeFormatted () {
      this.getActiveClients()
    },
    activeIndex () {
      if (this.activeIndex >= 0) {
        this.selectedClient = this.activeClients[this.activeIndex]
      }
    }
  },
  methods: {
    setSelected (relationship, index) {
      this.activeIndex = index
      this.$emit('selected', relationship, index)
    }
  },
  computed: {
    activeClientsRequest () {
      return this.$store.getters.getRequestById(LIST_ACTIVE_CLIENTS_REQ, true)
    },
    activeClients () {
      return this.getObjectPath(
        this.activeClientsRequest,
        'result.data.results',
        []
      )
    },
    filteredActiveClients () {
      if (this.searchString && this.searchString.length > 0) {
        return this.activeClients.filter((item) => {
          let indexString = `${item.client.id} ${item.client.first_name} ${item.client.last_name} ${item.client.email} ${item.client.phone_number}`.toLowerCase()
          let searchMatch = indexString
                              .indexOf(this.searchString.toLowerCase()) > -1
          if (searchMatch) {
            return item
          }
        })
      } else {
        return this.activeClients
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ActiveClients.vue?311da413